import { gql } from '@apollo/client';

export const ASSIGN_REELS_TO_CABLE = gql`
  mutation AssignReelsToCable($assignReelsToCableInput: AssignReelsToCableInput!) {
    assignReelsToCable(assignReelsToCableInput: $assignReelsToCableInput) {
      errors
      infos
      cableId
      cableReels {
        id
        reelId
        cableId
        cutLength
        assignedLength
        sequenceNumber
        reel {
          id
          tag
          badLength
          totalLength
          usedLength
        }
      }
    }
  }
`;
